// extracted by mini-css-extract-plugin
module.exports = {"root":"FullDetailsBarTab_root__fgFrP","text":"FullDetailsBarTab_text__uSUE4"};